"use strict";
import $ from "jquery";
import _ from "underscore";
import DataStoreService from "../accounts_payable/data_store_service";
import ApiService from "../services/api_service";
const inFlightMarkAsProcessed = /* @__PURE__ */ new Map();
const SAVED_INVOICE_FIELDS = [
  "source_invoice_number",
  "source_invoice_date",
  "source_invoice_amount",
  "quickpay",
  "disposition",
  "amount_to_pay",
  "quickpay_disposition",
  "carrier_id",
  "date_to_pay",
  "tms_carrier_payable_id",
  "extracted_fields",
  "labels"
];
export default {
  updating: [],
  updatingDeliveryDocuments: [],
  _cleanInvoice: function(carrierInvoice) {
    var justInvoice = _.pick(carrierInvoice, ...SAVED_INVOICE_FIELDS);
    if (justInvoice.source_invoice_amount === "NaN") {
      justInvoice.source_invoice_amount = null;
      justInvoice.amount_to_pay = null;
    }
    return justInvoice;
  },
  runRules: function(carrierInvoiceId) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.ajax({
        url: "/api/carrier_invoices/" + carrierInvoiceId + "/run_rules",
        type: "post"
      })
    ).then(DataStoreService.responseHandler, _.identity);
  },
  update: function(carrierInvoiceId, carrierInvoice, customerId) {
    if (_.contains(this.updating, carrierInvoiceId)) {
      return Promise.resolve();
    }
    this.updating.push(carrierInvoiceId);
    const cleanedInvoice = this._cleanInvoice(carrierInvoice);
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.ajax({
        url: "/api/carrier_invoices/" + carrierInvoiceId,
        type: "put",
        data: JSON.stringify({
          carrier_invoice: cleanedInvoice,
          customer_id: customerId
        }),
        contentType: "application/json"
      })
    ).then((data) => {
      DataStoreService.updateStores(data);
      this.updating.splice(this.updating.indexOf(carrierInvoiceId));
      return {};
    }).catch((err) => {
      this.updating.splice(this.updating.indexOf(carrierInvoiceId));
      return { error: err };
    });
  },
  markAsException: function(carrierInvoiceId, note, emailId, payment, carrierId) {
    return this._save("save_with_errors", carrierInvoiceId, {
      note,
      email_id: emailId,
      payment,
      carrier_id: carrierId
    });
  },
  markAsProcessed: function(carrierInvoiceId, payment, carrierId, note, approve, carrierInvoice) {
    const save = () => this._save("mark_as_processed", carrierInvoiceId, {
      payment,
      carrier_id: carrierId,
      note,
      approve,
      carrier_invoice: this._cleanInvoice(carrierInvoice)
    });
    const key = String(carrierInvoiceId);
    const pending = inFlightMarkAsProcessed.get(key);
    if (pending) {
      return pending;
    }
    const request = save().finally(() => inFlightMarkAsProcessed.delete(key));
    inFlightMarkAsProcessed.set(key, request);
    return request;
  },
  _save: function(method, carrierInvoiceId, args) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.ajax({
        url: "/api/carrier_invoices/" + carrierInvoiceId + "/" + method,
        type: "post",
        contentType: "application/json",
        data: JSON.stringify(args || {})
      }).then(DataStoreService.responseHandler, _.identity)
    );
  },
  unApprove: function(carrierInvoiceId) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.post(
        "/api/carrier_invoices/" + carrierInvoiceId + "/unapprove",
        {}
      ).then(function(data) {
        DataStoreService.updateStores(data);
        return data;
      })
    );
  },
  abandon: function(carrierInvoiceId, reason) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.post("/api/carrier_invoices/" + carrierInvoiceId + "/abandon", {
        reason
      }).then(function(data) {
        DataStoreService.updateStores(data);
        return data;
      })
    );
  },
  forwardInvoiceDocumentsToTriumph: function(carrierInvoiceId) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.ajax({
        url: "/api/carrier_invoices/" + carrierInvoiceId + "/forward_invoice_documents_to_triumph",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({ id: carrierInvoiceId })
      }).then(DataStoreService.responseHandler, _.identity)
    );
  },
  revive: function(carrierInvoiceId) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.post("/api/carrier_invoices/" + carrierInvoiceId + "/revive").then(
        function(data) {
          DataStoreService.updateStores(data);
          return data;
        }
      )
    );
  }
};
